import { render } from "./VerifyPwd.vue?vue&type=template&id=725e5f54&scoped=true"
import script from "./VerifyPwd.vue?vue&type=script&lang=js"
export * from "./VerifyPwd.vue?vue&type=script&lang=js"

import "./VerifyPwd.vue?vue&type=style&index=0&id=725e5f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725e5f54"]])

export default __exports__